export function warn (msg: string): void {
  console.warn(`[Vue3-lazy warn]: ${msg}`)
}
